import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContasBancariasDs, criarTipoAlvaraDiversoDs } from "../../DataSources";

const localStorageKey = "cadastroTivoAlvaraDiversoGridState";


export default class TipoAlvaraDiversoBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
        this.tipoAlvaraDiversoDs = criarTipoAlvaraDiversoDs();
        this.moedas = [
            { id: 0, descricao: "Real" },
            { id: 1, descricao: "Unidade Fiscal" }
        ]
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("/alvarasdiversos/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="TIPOS DE ALVARÁS DIVERSOS" novoCb={this.novoRegistro.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={this.tipoAlvaraDiversoDs}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} mode useIcons={true} />
                            
                            <Column dataField={'id'} caption={"#"} allowEditing={false} visible={false} />
                            <Column dataField={'sequencial'} caption={"#"} allowEditing={false} width={"100px"} alignment={"center"} />
                            <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                <FormItem visible={false}></FormItem>
                            </Column>
                            <Column dataField={'titulo'} caption={"Título"} />
                            <Column dataField={'unidadeCobranca'} caption={"Unidade de Cobrança"} />
                            <Column dataField={'tipoMoeda'} caption={"Moeda"}>
                                <Lookup dataSource={this.moedas} displayExpr={"descricao"} valueExpr={"id"} />
                            </Column>
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novoRegistro() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("/alvarasdiversos/novo");
    }

}